import { Icon, Paper, Typography } from "@mui/material";
import { FolderDto } from "../../../api/psc";

// updated
export default function ProjectFolderItem(props: { folder: FolderDto }) {
    return (
        <Paper sx={{ p: 1, display: "flex", alignItems: "center" }}>
            <Icon sx={{ color: `#${props.folder.color}`, mr: 1 }}>folder</Icon>
            <Typography>{props.folder.title}</Typography>
        </Paper>
    );
}
